import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';
import { ServiceContractRecordsFilters } from 'src/common/models/contract';

const buildQueryString = (filters?: ServiceContractRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.isActive !== undefined) {
        filtersList.push(`active=${filters.isActive}`)
    }
    if (filters?.nextServiceDebitRange !== undefined) {
        filtersList.push(`nextServiceDebitRange=${filters.nextServiceDebitRange}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getPayableContractRecordsApi(action: Actions.GetPayableContractsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.PAYABLE_CONTRACT.GET_RECORDS(buildQueryString(action.filters)))
        yield put(Actions.getPayableContractsApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getPayableContractsApiError(getErrorFromResponse(err)));
    }
}

function* createPayableContractApi(action: Actions.CreatePayableContractAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.PAYABLE_CONTRACT.CREATE, action.payableContract)
        yield put(Actions.createPayableContractApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.createPayableContractApiError(getErrorFromResponse(err)));
    }
}

function* getPayableContractByIdApi(action: Actions.GetPayableContractByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.PAYABLE_CONTRACT.GET_BY_ID(action.id))
        yield put(Actions.getPayableContractByIdApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getPayableContractByIdApiError(getErrorFromResponse(err)));
    }
}

function* updatePayableContractApi(action: Actions.UpdatePayableContractAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().put, Urls.BACKEND.PAYABLE_CONTRACT.UPDATE, action.payableContract)
        yield put(Actions.updatePayableContractApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.updatePayableContractApiError(getErrorFromResponse(err)));
    }
}

export default function* payableContractSagas() {
    yield takeLatest(ActionTypes.GET_PAYABLE_CONTRACTS_API, getPayableContractRecordsApi)
    yield takeLatest(ActionTypes.CREATE_PAYABLE_CONTRACT_API, createPayableContractApi)
    yield takeLatest(ActionTypes.GET_PAYABLE_CONTRACT_BY_ID_API, getPayableContractByIdApi)
    yield takeLatest(ActionTypes.UPDATE_PAYABLE_CONTRACT_API, updatePayableContractApi)
}